module.exports = __webpack_public_path__ + "static/media/twitter-new.503073fe.svg";